import { allLocales, type Locale } from "shared-core/services/i18n.ts";

const DEFAULT_PUBLIC_SITE_URL = "https://www.controla.ai";

export function getPublicSiteUrl(
  locale: string,
  path: string,
  publicSiteUrl: string = import.meta.env.VITE_PUBLIC_SITE_URL ||
    DEFAULT_PUBLIC_SITE_URL,
): string {
  const language = locale.split("-")[0];
  const supportedLocale = allLocales.includes(language as Locale)
    ? language
    : "en";
  return new URL(
    `/${supportedLocale}/${path}`,
    publicSiteUrl || DEFAULT_PUBLIC_SITE_URL,
  ).href;
}

export function getPublicPrivacyPolicyUrl(locale: string): string {
  return getPublicSiteUrl(locale, "privacy-policy");
}
